import {Component, Input} from '@angular/core';
import {environment} from '@environments/environment';
import {FileUtils} from "@wba/utils/file.utils";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Component({
  selector: 'wba-download-link',
  template: `
    <a
      [ngClass]="className"
      href="#"
      [id]="_id"
      [attr.aria-label]="ariaLabel"
      (click)="clickEvent($event)"
      (contextmenu)="clickEvent($event)"
      data-analytics-track="true"
      data-analytics-category="Download-Link"
      data-analytics-action="klick"
      [attr.data-analytics-name]="piwikTitle"
      data-analytics-value=""
      [attr.data-testid]="data_testid"
    >
      <ng-content></ng-content>
    </a>
  `,
  standalone: false
})
export class DownloadLinkComponent {
  @Input() _id: string;
  @Input() url: string;
  @Input() fileName: string;
  @Input() ariaLabel: string;
  @Input() className = 'ba-link-icon ba-icon-download ba-link-secondary';
  @Input() piwikTitle = '';
  @Input() data_testid = '';

  public host = `${environment.backend.host}/pd/v1/`;

  constructor(private readonly httpClient: HttpClient) {
  }

  async clickEvent(event: Event) {

    event.preventDefault();
    const request = this.httpClient.get(this.host + this.url, {
      responseType: 'blob',
      observe: 'response'
    });
    const response = await firstValueFrom(request);
    FileUtils.downloadFile(response, this.fileName)
  }
}
